import cookies from '@Ravnur-Inc/helpers/cookies';

import { detectCookieName } from './detect-cookie-name';

export function getAuthToken() {
  return cookies.getCookie(detectCookieName());
}
